import React ,{useEffect}from "react";
import "./AboutUs.css";
import AOS from 'aos';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    AOS.init();
      window.scrollTo(0, 0)
  }, [])
  return (
    <div className="container-fluid" id="about-us-page">
      <div className="row first-row">
        <div className="col left-col">
          <h3>
            Who We Are
            <hr />
          </h3>
          <p>
            Unique Technologies, headquartered in Noida, Delhi NCR, is a leading
            provider of automation solutions since 2012. Certified with ISO
            14001:2015 and ISO 9001:2015, we specialize in water treatment
            plants, STPs, tubewell automation, solar water pumping, and street
            light automation systems. Known for manufacturing PLC/SCADA panels,
            VFD panels, LV/MV panels, and more, we excel in problem-solving,
            design, engineering, installation, and optimization.
          </p>
        </div>
        <div className="col right-col">
          <img
            src="Images/logo.png
          "
            alt=""
          />
        </div>
      </div>

      <hr />
      <div className="row specialized-in">
        <div className="row">
          <div className="col left-col" data-aos="fade-right" data-aos-offset="250"  data-aos-duration="1000">
            We <br />
            Specialized <br />
            in
          </div>
          <div className="col right-col">
            <div className="specialization" data-aos="fade-left" data-aos-offset="200"  data-aos-duration="500">Complete solution for solar pump with solar drive</div>
            <div className="specialization" data-aos="fade-left" data-aos-offset="180"  data-aos-duration="600">Solar Power Plant</div>
            <div className="specialization"
            data-aos="fade-left" data-aos-offset="160"  data-aos-duration="700">Integrated solution for water and waste water</div>
            <div className="specialization" 
            data-aos="fade-left" data-aos-offset="140"  data-aos-duration="800">Flow meter with remote monitoring systems (As per CPCB guideline)</div>
            <div className="specialization"
            data-aos="fade-left" data-aos-offset="120"  data-aos-duration="900">Tube well/Pump Automation (SCADA)</div>
            <div className="specialization"
            data-aos="fade-left" data-aos-offset="100"  data-aos-duration="1000">MCCB, PCC Panel Manufacture</div>
          </div>
        </div>
        </div>
      <div className="row second-row">
        <h3
        >Our Values</h3>
        <p>At Unique Technologies, our values are rooted in innovation, sustainability, and unwavering commitment to customer satisfaction, driving us to deliver cutting-edge automation solutions with environmental consciousness and excellence.</p>
        <div className="col">
          
          <div className="col text-col">
          <div className="col first-img-col">
            
          </div>
            <h5>Industry Leadership</h5>
            
            <p>
              Unique Technologies, based in Noida, Delhi NCR, leads in
              automation solutions since 2012, with ISO 14001:2015 and ISO
              9001:2015 certifications, catering to diverse technical needs and
              commercial viability.
            </p>
          </div>
        </div>
        <div className="col">
          <div className="col text-col">
          <div className="col second-img-col"></div>
            <h5>Comprehensive Solutions</h5>
           
            <p>
              Specializing in water treatment, STPs, tubewell automation, solar
              water pumping, and street light automation, we offer tailored
              solutions for various industries.
            </p>
          </div>
        </div>
        <div className="col">
          <div className="col text-col">
        <div className="col third-img-col"></div>
            <h5>Trusted Manufacturing</h5>
            
            <p>
            Renowned for manufacturing reliable PLC/SCADA panels, VFD panels, LV/MV panels, and more, we ensure quality and efficiency in every product.
            </p>
          </div>
        </div>
        <div className="col">
          <div className="col text-col">
        <div className="col fourth-img-col"></div>
            <h5>Customer-Centric Approach</h5>
          
            <p>
            Beginning with identifying customer challenges, we design, evaluate, engineer, install, and optimize solutions, prioritizing customer satisfaction and problem-solving.
            </p>
          </div>
        </div>

        <div className="col">
          <div className="col text-col">
        <div className="col fifth-img-col"></div>
            <h5>Innovation and Adaptability</h5>
            
            <p>
            With a focus on innovation, Unique Technologies continuously adapts to emerging technologies and industry trends, ensuring cutting-edge solutions that meet evolving needs and standards.
            </p>
          </div>
        </div>

        <div className="col">
          <div className="col text-col">
        <div className="col sixth-img-col"></div>
            <h5>Sustainable Solutions</h5>
            
            <p>
            Committed to environmental responsibility, our services emphasize energy efficiency and sustainability, contributing to eco-friendly operations and reducing carbon footprints for our clients.
            </p>
          </div>
        </div>
      </div>
      <hr />
      <div className="row third-row">
        <div className="col">
          <h1>About Uniqe Technologies</h1>
          <p>Unique Technologies is a leading automation solution providing company based at Noida, Delhi NCR. We are engaged in automation solutions and products which are well suited to plant's technical needs and commercial viability. Unique Technologies founded in 2012. An ISO 14001: 2015 and ISO 9001 : 2015 certified company .We offer better services of Water Treatment Plant, Waste Water Treatment Plant / STP , Tubewell Automation system, Solar water pumping system and street light Automation system. Unique Technologies is well known as a reliable manufacturer of PLC/SCADA Automation panel, VFD Panel, LV/MV panel, Centralized street light automation control panel, MCCB distribution panel, Energy Efficient pump starter control panel and Star/Delta/DOL Star panel since 2012. . We start from customer problem areas - design the concept - evaluate the viability engineer the solution - install and optimize</p>
          <br />
          <p>We support our customers by giving end to end solutions which includes installation, commissioning and service of our own panels. Or as per client's needs, we also support them in installation and commissioning by themselve. Our company is currently operating under the skillful leadership of our mentor, Mr. Dharmendra Pandey. Owing to his vast experience and innovative business ideas, we have been able to cater to a huge clientele across the world.</p>
        </div>
      </div>
      <div className="row fourth-row">
        <div className="col left-col">
          <br /><br /><br /> &nbsp;
        </div>
        <div className="col right-col"></div>
      </div>

      
    </div>
  );
};

export default AboutUs;
